module.exports = __webpack_public_path__ + "src/assets/img/card01.2e2c1917.png";